export default __webpack_public_path__ + "static/logo-e50bf70c07330d3e8bd6faa9e01f5692.png";